// Input validation ve sanitization utility'si
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  
  // HTML etiketlerini temizle
  return input
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;')
    .trim();
};

export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email) && email.length <= 254;
};

export const validatePassword = (password) => {
  // En az 8 karakter, büyük harf, küçük harf, rakam
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&.]{8,}$/;
  return passwordRegex.test(password);
};

export const validateUrl = (url) => {
  try {
    const urlObj = new URL(url);
    // Sadece http ve https protokollerine izin ver
    return ['http:', 'https:'].includes(urlObj.protocol);
  } catch {
    return false;
  }
};

export const validateAppData = (data) => {
  const errors = {};
  
  // Title validation
  if (!data.name || data.name.trim().length < 3) {
    errors.name = 'Uygulama adı en az 3 karakter olmalıdır';
  } else if (data.name.length > 100) {
    errors.name = 'Uygulama adı en fazla 100 karakter olabilir';
  }
  
  // Description validation
  if (!data.description || data.description.trim().length < 10) {
    errors.description = 'Açıklama en az 10 karakter olmalıdır';
  } else if (data.description.length > 1000) {
    errors.description = 'Açıklama en fazla 1000 karakter olabilir';
  }
  
  // Test URL validation
  if (data.testUrl && !validateUrl(data.testUrl)) {
    errors.testUrl = 'Geçerli bir URL giriniz';
  }
  
  // Platform validation
  const validPlatforms = ['Android', 'iOS', 'Web', 'Desktop'];
  if (!data.platform || !validPlatforms.includes(data.platform)) {
    errors.platform = 'Geçerli bir platform seçiniz';
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Bu fonksiyon artık sanitizer.js'de mevcut
// import { sanitizeAppData } from '../utils/sanitizer'; kullanın
